import React, { useEffect, useState } from 'react';
import { BsFillCreditCardFill, BsBicycle } from "react-icons/bs";
import { FaWallet } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { addPementStatus } from '../../features/checkout/checkoutSlice';
import Coupon from './Coupon';

const Payment = () => {
    const {paymentStatus} = useSelector((state) => state.checkout);
    const dispatch = useDispatch();

    const handlePamentStatus = (e) => {
        dispatch(addPementStatus(e));
    }

    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    
    return (
        <div>
            <div className="title-div flex content-center gap-1">
                <div className="grid content-center">
                    <BsFillCreditCardFill className='text-xl text-bnd-1' />
                </div>
                <h3 className='text-lg font-medium text-gray-500 font-poppins'>{translate ? "Payment Method" : "মূল্যপরিশোধ পদ্ধতি"} </h3>
            </div>
            <div className=''>
                <div onClick={() => handlePamentStatus('paid')} className={`flex py-2 my-2 border justify-center gap-1 w-full cursor-pointer ${paymentStatus ? paymentStatus === 'paid' && ' bg-bnd-py text-white' : 'bg-bnd-py text-white'}`}>
                    <div className="grid content-center justify-center">
                        <BsFillCreditCardFill className='text-lg' />
                    </div>
                    <p className='py-1 font-normal'>{translate ? "Online Payment" : "অনলাইন পেমেন্ট"}</p>
                </div>
                <div onClick={() => handlePamentStatus('unpaid')} className={`flex py-2 my-2 border justify-center gap-1 w-full cursor-pointer  ${paymentStatus === 'unpaid' && ' bg-bnd-py text-white'}`}>
                    <div className="grid content-center justify-center">
                        <FaWallet className='text-lg' />
                    </div>
                    <p className='py-1 font-normal'>{translate ? "Cash on Delivery" : "ক্যাশ অন ডেলিভারী"}</p>
                </div>
            </div>
            <div className='border-b border-dashed py-2 mb-3'></div>


            {/* discaunt code  */}
            <Coupon/>

            <div className='border-b border-dashed py-2 mb-3'></div>

            {/* Delivery Company  */}
            <div className="title-div flex content-center gap-1">
                <div className="grid content-center">
                    <BsBicycle className='text-2xl text-bnd-1' />
                </div>
                <h3 className='text-lg font-medium text-gray-500 font-poppins'>{translate ? "Delivery Time" : "ডেলিভারি সময়"} </h3>
            </div>
            <div className=''>
                <div className='py-3 my-2 border bg-bnd-py text-white gap-1 w-full text-center'>
                    <p className='mb-1 text-md font-medium'>{translate ? "24 hours within Dhaka." : "ঢাকার মধ্যে ২৪ ঘণ্টা।"}</p>
                    <p className='text-xs font-normal'>{translate ? "3-5 days outside Dhaka" : "ঢাকার বাইরে ৩-৪ দিন"}</p>
                </div>
            </div>

            <div className='border-b border-dashed py-2 mb-3'></div>

        </div>
    );
};

export default Payment;